/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageProductSortimentPricingPageResponse } from '../../models/page-product-sortiment-pricing-page-response';
import { ProductSortimentPricingFilter } from '../../models/product-sortiment-pricing-filter';

export interface GetProductSortimentPricingList$Params {

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
      body: ProductSortimentPricingFilter
}

export function getProductSortimentPricingList(http: HttpClient, rootUrl: string, params: GetProductSortimentPricingList$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductSortimentPricingPageResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductSortimentPricingList.PATH, 'post');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageProductSortimentPricingPageResponse>;
    })
  );
}

getProductSortimentPricingList.PATH = '/pricing';
